<!--
 * @Description: 考务考试计划 详情
 * @Author: PF
 * @Date: 2023-04-14 18:40:59.405
 * @LastEditors: PF
 * @LastEditTime: 2024-10-18 16:23:02
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="bu-zhou-tiao">
        <el-steps :active="buZhouTiao" finish-status="success" simple style="width:900px; margin-bottom: 20px;">
          <el-step title="基本信息" />
          <el-step title="科目场次" />
        </el-steps>
      </div>
      <div class="el-dialog-div">
        <!-- 第一步 -->
        <div class="wp100" v-if="buZhou == 1">
          <el-descriptions :column="4" border class="mb10">
            <el-descriptions-item label="考试学期" label-align="right" align="left" width="140px" span="2">{{ruleForm.ksxqmc}}</el-descriptions-item>
            <el-descriptions-item label="考试类型" label-align="right" align="left" width="140px" span="2">{{ruleForm.kslxbt}}</el-descriptions-item>
            <el-descriptions-item label="考试名称" label-align="right" align="left" span="4">{{ruleForm.ksmc}}</el-descriptions-item>
            <el-descriptions-item label="考试开始日期" label-align="right" align="left" span="2">{{ruleForm.ksksrq}}</el-descriptions-item>
            <el-descriptions-item label="考试结束日期" label-align="right" align="left" span="2">{{ruleForm.ksjsrq}}</el-descriptions-item>
            <el-descriptions-item label="成绩录入开始日期" label-align="right" align="left" span="2">{{ruleForm.cjlrksrq}}</el-descriptions-item>
            <el-descriptions-item label="成绩录入结束日期" label-align="right" align="left" span="2">{{ruleForm.cjlrjsrq}}</el-descriptions-item>
            <el-descriptions-item label="组卷要求完成时间" label-align="right" align="left" span="2">{{ruleForm.zjyqwcsj}}</el-descriptions-item>
            <el-descriptions-item label="分配考生方式" label-align="right" align="left" span="2"><span v-if="ruleForm.fpksfs">{{ruleForm.fpksfs.name}}</span></el-descriptions-item>
            <el-descriptions-item label="起始考号" label-align="right" align="left" span="2">{{ruleForm.qskh}}</el-descriptions-item>
            <el-descriptions-item label="参考班级数" label-align="right" align="left" span="2">{{ruleForm.ckbjs}}</el-descriptions-item>
            <el-descriptions-item label="参考学生数" label-align="right" align="left" span="2">{{ruleForm.ckxss}}</el-descriptions-item>
            <el-descriptions-item label="考试科目数" label-align="right" align="left" span="2">{{ruleForm.kskms}}</el-descriptions-item>
            <el-descriptions-item label="考场数" label-align="right" align="left" span="2">{{ruleForm.kcs}}</el-descriptions-item>
            <el-descriptions-item label="审核状态" label-align="right" align="left" span="2">
              <span v-for="(item, index) in shztData.list" :key="index">
                <span v-if="ruleForm.shzt==item.value">{{item.name}}</span>
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="考试状态" label-align="right" align="left" span="2">
              <span v-for="(item, index) in ksztData.list" :key="index">
                <span v-if="ruleForm.kszt==item.value">{{item.name}}</span>
              </span>
            </el-descriptions-item>
          </el-descriptions>
          <el-table class="mb10" :data="ruleForm.ccs" border style="width:100%">
            <el-table-column label="场次" prop="ksxqmc" align="center">
              <template #default="scope">第{{scope.row.ccs}}场</template>
            </el-table-column>
            <el-table-column label="开始时间" prop="kskssjStr" align="center"></el-table-column>
            <el-table-column label="结束时间" prop="ksjssjStr" align="center"></el-table-column>
            <el-table-column label="科目" min-width="100" align="center">
              <template #default="scope">
                <span v-for="(item, index) in scope.row.kms" :key="index">
                  <span v-if="index>0">、</span>
                  <span>{{ item.kskmmc }}</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="mb10">
            <div style="color: var(--el-text-color-primary);font-size: 16px;font-weight: 700;">参考班级</div>
            <el-tag style="margin-left:10px;margin-top:10px;" v-for="(item, index) in ruleForm.bjs" :key="index" type="info" size="large">{{item.bjmc}}</el-tag>
          </div>
        </div>
        <!-- 第二步 -->
        <div class="wp100" v-if="buZhou == 2">
          <el-container class="hp100">
            <el-aside width="300px">
              <el-menu v-if="ruleForm.jxjhkmccs.length" class="el-menu-vertical-demo" :default-openeds="[0-0]" default-active="0-0">
                <el-sub-menu v-for="(item, index) in ruleForm.jxjhkmccs" :key="index" :index="index">
                  <template #title>
                    <span>{{item.treeName}}</span>
                  </template>
                  <el-menu-item v-for="(val, i) in item.children" :key="i" :index="index+'-'+i" @click="jiaoXueJiHuaClick(val, item)">{{val.treeName}}</el-menu-item>
                </el-sub-menu>
              </el-menu>
              <div v-else class="zan-wu">暂无数据</div>
            </el-aside>
            <el-main class="pt0 pl10 pr0 pb0 hp100">
              <el-row :gutter="10" class="wl0 mr0 hp100">
                <el-col :span="14" class="hp100">
                  <el-table :data="dqjxjh.kms" height="100%" border stripe>
                    <!-- 冻结列-Left BEGIN -->
                    <el-table-column label="科目" prop="kskmmc" min-width="100" fixed align="center" />
                    <el-table-column label="排考方式" prop="pkfs" width="120" align="center">
                      <template #default="scope">
                        <span v-for="(item, index) in pkfsData.list" :key="index">
                          <span v-if="scope.row.pkfs == item.value">{{item.name}}</span>
                        </span>
                      </template>
                    </el-table-column>
                    <!-- 冻结列-Left END -->
                    <el-table-column label="是否统一时间考试" prop="sftysjks" width="180" align="center">
                      <template #default="scope">
                        <span v-if="scope.row.sftysjks == true">是</span>
                        <span v-if="scope.row.sftysjks == false">否</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="录入成绩方式" prop="lrcjfs" width="150" align="center">
                      <template #default="scope">
                        <span v-for="(item, index) in lrcjfsData.list" :key="index">
                          <span v-if="scope.row.lrcjfs === item.value">{{item.name}}</span>
                        </span>
                      </template>
                    </el-table-column>
                    <!-- 冻结列-Right BEGIN -->
                    <el-table-column label="操作" width="80" fixed="right" align="center">
                      <template #default="scope">
                        <el-button link type="success" @click="openDetailKeMu=true; rowKeMu=scope.row">详情</el-button>
                      </template>
                    </el-table-column>
                    <!-- 冻结列-Right END -->
                  </el-table>
                </el-col>
                <el-col :span="10">
                  <el-table :data="dqjxjh.kmccs" height="100%" border>
                    <!-- 冻结列-Left BEGIN -->
                    <el-table-column label="场次" prop="ccs" width="230" align="center">
                      <template #default="scope">
                        第{{ scope.row.ccs }}场 {{ scope.row.ksrq }} {{ scope.row.kskssjStr }}<span v-if="scope.row.kskssjStr && scope.row.ksjssjStr">至</span>{{ scope.row.ksjssjStr }}
                      </template>
                    </el-table-column>
                    <el-table-column label="科目" prop="kms" min-width="100" align="center" />
                    <!-- 冻结列-Right END -->
                  </el-table>
                </el-col>
              </el-row>
            </el-main>
          </el-container>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button v-if="buZhou == 1" type="primary" @click="buZhouClick(2)">下一步</el-button>
            <el-button v-if="buZhou == 2" type="primary" @click="buZhouClick(1)">上一步</el-button>
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <kemudetail v-if="openDetailKeMu" v-model:openDetail="openDetailKeMu" :row="rowKeMu" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { actionPost, loadSelect, closeWindow } from '@/api/common.js'
import kemudetail from './kemudetail'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({ jxjhkmccs: [], ccs: [{ ccs: 1, ksrq: '', kskssjStr: '', ksjssjStr: '' }], bjs: [] })
const emits = defineEmits(['update:openDetail'])
const openDetailKeMu = ref(false)
const rowKeMu = ref()
// 加载 审核状态 下拉框
const shztData = ref({ list: [] })
// 加载 考试状态 下拉框
const ksztData = ref({ list: [] })
const bjlx = ref()
// 步骤切换
const buZhouTiao = ref(0)
const buZhou = ref(1)
const buZhouClick = async (val) => {
  if (val === 2) {
    buZhou.value = 2
    buZhouTiao.value = 1
  } else if (val === 1) {
    buZhou.value = 1
    buZhouTiao.value = 0
  }
}

const dqjxjh = ref({ kms: [], kmccs: [] }) // 当前教学计划
const jiaoXueJiHuaClick = (data) => {
  dqjxjh.value.kms = data.kms
  dqjxjh.value.kmccs = []
  ruleForm.value.ccs.forEach(element => {
    const obj = {
      ccs: 1,
      ksrq: element.ksrq,
      kskssjStr: element.kskssjStr,
      ksjssjStr: element.ksjssjStr
    }
    data.kmccs.forEach(item => {
      if (item.ccs === element.ccs) {
        obj.kms = item.kskmids.map(id => element.kms.find(ite => ite.kskmid === id).kskmmc)
      }
    })
    obj.kms = obj.kms.join('、')
    dqjxjh.value.kmccs.push(obj)
  })
}
const pkfsData = ref({ list: [] }) // 排考方式
const lrcjfsData = ref({ list: [] }) // 录入成绩方式
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shenhezhuangtai', data: shztData })
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/kaoshizhuangtai', data: ksztData })
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/luruchengjifangshi', data: lrcjfsData })
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshikemu/paikaofangshi', data: pkfsData })
      const o = { url: '/api/v2/jiaowu/kaowukaoshijihua/kaoshijihuaxiugaixiangqing/' + props.row.id, data: {} }
      actionPost(o).then((res) => {
        if (res.code === 200) {
          bjlx.value = 4
          res.data.id = props.row.id
          res.data.bjs.map(item => {
            item.bjlx = 4
            item.bjlxmc = item.bjmc
            item.bjlxid = item.bjid
            return item
          })
          ruleForm.value = res.data
          jiaoXueJiHuaClick(res.data.jxjhkmccs[0].children[0], 0, 0, res.data.jxjhkmccs[0].treeId)
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.bu-zhou-tiao {
  width: 100%;
  display: flex;
  justify-content: center;
}
.el-dialog-div {
  width: 100%;
  height: calc(100% - 66px);
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
}
.demo-date-picker {
  display: flex;
  width: 100%;
  padding: 0;
  flex-wrap: wrap;
}
.demo-date-picker .block {
  padding: 30px 0;
  text-align: center;
  border-right: solid 1px var(--el-border-color);
  flex: 1;
}
.demo-date-picker .block:last-child {
  border-right: none;
}
.demo-date-picker .demonstration {
  display: block;
  color: var(--el-text-color-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}
.tag {
  width: 100%;
}
.btn {
  display: flex;
  justify-content: space-between;
}
:deep element.style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 0px;
  padding-left: 0px;
}
.el-menu {
  border-right: none;
}
.zan-wu {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--el-font-size-base);
  color: var(--el-text-color-secondary);
}
</style>
